import { Constants } from 'constants';

import React, { useEffect } from 'react';
import { Button, Grid, Typography } from '@genie-ui/react';
import PropTypes from 'prop-types';

import GartnerBuild from 'assets/images/GartnerBuild';

import './ErrorPage.scss';

function ErrorPage({
  handleClick,
  title,
  body1,
  body2,
  label,
  descRequired,
  actisDataObj,
  actisKey,
}) {
  useEffect(() => {
    let actisError = {};
    switch (title) {
      case Constants.ACCESS_DENIED_ERROR.TITLE:
        actisError = Constants.ACTIS.ACCESS_DENIED;
        break;
      case Constants.PAGE_NOT_FOUND_ERROR.TITLE:
        actisError = Constants.ACTIS.PAGE_NOT_FOUND;
        break;
      default:
        actisError = Constants.ACTIS.ERROR_PAGE;
    }

    if (actisDataObj) {
      window.pushEvent?.({
        ...actisError,
        ...actisDataObj,
      }, actisKey);
    }
  }, [title, actisDataObj]);

  const onClick = () => {
    if (handleClick) {
      handleClick();
    } else {
      window.location.reload();
    }
  };

  return (
    <Grid container className="error-page__container">
      <GartnerBuild />
      <Grid container className="error-body">
        <Typography variant="h1" className="error-body__title">
          {title}
        </Typography>
        <Typography variant="body1" className="error-body__help-text">
          {body1}
        </Typography>
        {descRequired && (
        <Typography variant="body1" className="error-body__help-text">
            {body2}
        </Typography>
        )}
        <Button
          variant="primary"
          className="error-body__reload"
          onClick={onClick}
        >
          {label}
        </Button>
      </Grid>
    </Grid>
  );
}

ErrorPage.propTypes = {
  handleClick: PropTypes.func,
  title: PropTypes.string,
  body1: PropTypes.string,
  body2: PropTypes.string,
  label: PropTypes.string,
  descRequired: PropTypes.bool,
  actisKey: PropTypes.string,
  actisDataObj: PropTypes.instanceOf(Object),
};

ErrorPage.defaultProps = {
  handleClick: null,
  title: Constants.DEFAULT_ERROR.TITLE,
  body1: Constants.DEFAULT_ERROR.BODY1,
  body2: Constants.DEFAULT_ERROR.BODY2,
  label: Constants.DEFAULT_ERROR.LABEL,
  descRequired: true,
  actisDataObj: {},
  actisKey: '',
};

export default ErrorPage;
